import { TrainingCourseDuration } from "@/features/training/model/Training/TrainingCourse";
import { TrainingSessionParticipants } from "@/features/training/model/Training/TrainingSessionParticipants";

import { UserSummary } from "@/model/User/UserSummary";

export class TrainingSession {
	Id: number;
	Information: string;
	Status: TrainingSessionStatus;
	Comment: string | null;
	SessionDate: Date;
	Duration: TrainingCourseDuration;
	FinishDate: Date | null;
	ExpiresDate: Date | null;
	Trainer: UserSummary;
	Students: TrainingSessionParticipants[];
	Retraining: boolean;
}

export class TrainingSessionSummary {
	Id: number;
	Name: string;
	Date: Date;
	CourseId: number;
	Retraining: boolean;
}

export enum TrainingSessionStatus {
	Active = "Active",
	Complete = "Complete",
	Archived = "Archived",
}

export class TrainingSessionsQueryOptions {
	StartDate?: string;
	EndDate?: string;
	Status?: TrainingSessionStatus;
}

export class TrainingSessionRequest {
	CourseId: number;
	Information: string;
	SessionDate: Date;
	ExpiresDate: Date | null;
	TrainerId: number;
	StudentIds: number[];
	GroupId: number | null;
	Standin?: boolean;
}

export class CompleteTrainingSessionRequest {
	Students: TrainingSessionParticipants[];
	Comment: string | null;
}
